import {
  fork,
  call,
  put,
  all,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import asyncInterface from '../../../../asyncInterface';
import { grant } from '../../../../services/apiServices';
import * as actionTypes from './actionTypes';

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.grantsDashboard.fetchAccountData(fetchPayload);
}

export function postCharityData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendGrant.postCharityData(fetchPayload.payload);
}

export function* currentPendingGrantsDataFetch(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.currentPendingGrantsSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.currentPendingGrantsFailedType,
      error,
    });
  }
}

export function* issuedGrantsDataFetch(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.issuedGrantsSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.issuedGrantsFailedType,
      error,
    });
  }
}

export function* lazyDataFetch(data) {
  yield put({
    type: actionTypes.lazyLoadDataLoaderType,
  });
  if (data.type === 'PENDING') {
    try {
      const response = yield call(fetchAccountData, data);
      yield put({
        type: actionTypes.lazyLoadPendingGrantsDataSuccessType,
        payload: response.data,
      });
    } catch (error) {
      yield put({
        type: actionTypes.lazyLoadPendingGrantsDataFailedType,
        error,
      });
    }
  } else if (data.type === 'COMPLETED') {
    try {
      const response = yield call(fetchAccountData, data);
      yield put({
        type: actionTypes.lazyLoadIssuedDataSuccessType,
        payload: response.data,
      });
    } catch (error) {
      yield put({
        type: actionTypes.lazyLoadIssuedDataFailedType,
        error,
      });
    }
  }
}

export function* saveGrantsData(res) {
  yield put({
    type: actionTypes.grantsDashboardDataSuccessType,
    payload: res.data,
  });
}

export function* fetchAllGrants(data) {
  yield put({ type: actionTypes.allGrantsDashboardDataLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.allGrantsDashboardDataSuccessType,
      payload: response.data,
    });
  } catch (err) {
    yield put({
      type: actionTypes.allGrantsDashboardDataFailedType,
      payload: err,
    });
  }
}

export function* grantDashboardDataFetch(data, allData) {
  yield put({ type: actionTypes.grantsDashboardDataLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield all([fork(saveGrantsData, response)]);
    if (response.data && response.data[0].y3 === true) {
      yield all([fork(fetchAllGrants, allData)]);
    }
  } catch (error) {
    yield put({
      type: actionTypes.grantsDashboardDataFailedType,
      payload: error,
    });
  }
}

export function* accountDataFecth(data) {
  yield put({ type: actionTypes.grantsAccountDataFetchLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.grantsAccountDataSuccessType,
      payload: response.data,
    });
  } catch (err) {
    yield put({ type: actionTypes.grantsAccountDataFailedType, payload: err });
  }
}

export function* grantsCountFetch(data) {
  yield put({ type: actionTypes.countDataFetchLoadingType });
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionTypes.countDataSuccessType,
      payload: response.data,
    });
  } catch (err) {
    yield put({ type: actionTypes.countDataFailureType, payload: err });
  }
}

export function* fetchGrantsDataWorker(fetchPayload) {
  yield all([
    fork(resetData),
    fork(accountDataFecth, fetchPayload.payload.metaData[0]),
    fork(grantsCountFetch, fetchPayload.payload.metaData[1]),
    fork(currentPendingGrantsDataFetch, fetchPayload.payload.metaData[2]),
    fork(issuedGrantsDataFetch, fetchPayload.payload.metaData[3]),
    fork(
      grantDashboardDataFetch,
      fetchPayload.payload.metaData[4],
      fetchPayload.payload.metaData[5]
    ),
  ]);
}

export function* fetchLazyDataWorker(fetchPayload) {
  yield all([fork(lazyDataFetch, fetchPayload.payload.metaData[0])]);
}

export function* fetchGrantsDashboardDataWatcher() {
  yield takeEvery(actionTypes.dashboardDataFetchType, fetchGrantsDataWorker);
}

export function* fetchLazyDataWatcher() {
  yield takeEvery(actionTypes.fetchLazyLoadDataType, fetchLazyDataWorker);
}

export function* putChartData(payload) {
  yield put({ type: actionTypes.storeGrantChartDataLoadingType });
  try {
    yield put({
      type: actionTypes.storeGrantChartDataSuccessType,
      payload: payload.payload,
    });
  } catch (err) {
    yield put({
      type: actionTypes.storeGrantChartDataFailedType,
      payload: err,
    });
  }
}

export function* putChartDataWorker(dataPayload) {
  yield all([fork(putChartData, dataPayload)]);
}

export function* putChartDataWatcher() {
  yield takeEvery(actionTypes.storeChartGrantsDataType, putChartDataWorker);
}

export function* resetData() {
  yield put({ type: actionTypes.resetDataGrantType });
}

// serach charity
export function* fetchAccountDataWorker(fetchPayload) {
  yield put({
    type: actionTypes.accountSelectedDataLoaderType,
    payload: '',
  });
  try {
    const response = yield call(
      fetchAccountData,
      fetchPayload.payload.metaData
    );
    yield put({
      type: actionTypes.accountSelectedDataSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.accountSelectedDataFailedType,
      error,
    });
  }
}

export function* postSearchCharityDataWorker(fetchPayload) {
  try {
    const response = yield call(postCharityData, fetchPayload);
    const serverDown = response.data === "The system is temporarily unavailable";
    if (typeof response.data === 'string') {
      yield put({
        type: actionTypes.searchCharityResponseType,
        payload: { hits: [], serverDown },
      });
    }
    yield put({
      type: actionTypes.searchCharityResponseType,
      payload: {...response.data.data, serverDown},
    });
  } catch (error) {
    yield put({
      type: actionTypes.searchCharityErrorResponseType,
      payload: error,
    });
  }
}

export function* fetchSearchGeminiDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    if (
      (typeof response.data === 'string' && response.data.length === 0) ||
      typeof response.data.message === 'string'
    ) {
      yield put({ type: actionTypes.searchGeminiResponseType, payload: [] });
    } else if (typeof response.data === 'string' && response.data.length > 0) {
      yield put({
        type: actionTypes.searchGeminiResponseType,
        payload: response.data,
      });
    }
    yield put({
      type: actionTypes.searchGeminiResponseType,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: actionTypes.searchGeminiErrorType, payload: error });
  }
}

export function* postSearchCityDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    yield put({
      type: actionTypes.searchCityResponseType,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: actionTypes.searchCityErrorType, payload: error });
  }
}

export function* postSearchCountyDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchAccountData, fetchPayload.payload);
    yield put({
      type: actionTypes.searchCountySuccessResponseType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.searchCountyErrResponseType,
      payload: error,
    });
  }
}

export function* updateFromWorker(fetchPayload) {
  yield put({
    type: actionTypes.updateFromCounterWorkerType,
    payload: fetchPayload,
  });
}

export function* updateFromLoadMoreWorker(fetchPayload) {
  yield put({
    type: actionTypes.updateFromLoadMoreCounterWorkerType,
    payload: fetchPayload,
  });
}

export function* fetchSelectedAccount() {
  yield takeEvery(actionTypes.fetchSelectedAccountType, fetchAccountDataWorker);
}

export function* postSearchCharity() {
  yield takeEvery(
    actionTypes.postCharitySearchType,
    postSearchCharityDataWorker
  );
}

export function* fetchSearchGemini() {
  yield takeEvery(actionTypes.searchGeminiType, fetchSearchGeminiDataWorker);
}

export function* postSearchCity() {
  yield takeEvery(actionTypes.postCitySerachType, postSearchCityDataWorker);
}

export function* postSearchCounty() {
  yield takeEvery(actionTypes.postCountySearchType, postSearchCountyDataWorker);
}

export function* updateFrom() {
  yield takeLatest(actionTypes.updateFromCounterType, updateFromWorker);
}
export function* updateLoadMoreFrom() {
  yield takeEvery(
    actionTypes.updateFromLoadingCounterType,
    updateFromLoadMoreWorker
  );
}

export function* removeCharityWatcher() {
  yield takeEvery(actionTypes.removeCharityType, removeCharityWorker);
}

export function* removeCharityWorker(fetchPayload) {
  try {
    const response = yield call(postCharityData, fetchPayload);
    yield put({
      type: actionTypes.removeCharitySuccessType,
      payload: fetchPayload,
    });
    if (fetchPayload.successFn) {
      fetchPayload.successFn();
    }
  } catch (error) {
    yield put({ type: actionTypes.removeCharityFailType, payload: error });
  }
}

export function* fetchSavedCharityWatcher() {
  yield takeLatest(actionTypes.fetchSavedCharityType, fetchSavedCharityWorker);
}

export function* fetchSavedCharityWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({
      type: actionTypes.fetchSavedCharitySuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: actionTypes.resetSavedCharityFlagType,
      payload: false,
    });
  }
}

export function* submitSavedDataWatcher() {
  yield takeEvery(actionTypes.saveCharityType, submitSavedDataWorker);
}

export function* submitSavedDataWorker(action) {
  try {
    const response = yield call(grant.suggestCharity, action.payload);
    const { charityData } = action.payload;
    yield put({
      type: actionTypes.saveCharitySuccessType,
      payload: response.data,
      prevData: charityData,
    });
    if (action.successFn) {
      action.successFn(response.data);
    }
  } catch (error) {
    const { charityData } = action.payload;
    yield put({
      type: actionTypes.saveCharityFailType,
      payload: error,
      prevData: charityData,
    });
  }
}

export function* submitSavedGeminiDataWatcher() {
  yield takeEvery(
    actionTypes.postGeminiSavedDataType,
    submitSavedGeminiDataWorker
  );
}

export function* submitSavedGeminiDataWorker(action) {
  try {
    const response = yield call(grant.addCharity, action.payload);
    const { charityData } = action.payload;
    yield put({
      type: actionTypes.submitSavedGeminiDataSuccessType,
      payload: response.data,
      prevData: charityData,
    });
    if (action.successFn) {
      action.successFn(response.data);
    }
  } catch (error) {
    const { charityData } = action.payload;
    yield put({
      type: actionTypes.submitSavedGeminiDataFailType,
      payload: error,
      prevData: charityData,
    });
  }
}

export function* addCharityWatcher() {
  yield takeLatest(actionTypes.addCharityType, addCharityWorker);
}

export function* addCharityWorker(action) {
  try {
    const response = yield call(grant.addCharity, action.payload);
    const charityData = action.selectedCharity;
    yield put({
      type: actionTypes.addCharitySuccessType,
      payload: response.data,
      prevData: charityData,
    });
    if (action.successFn) {
      action.successFn(response.data);
    }
  } catch (error) {
    const charityData = action.selectedCharity;
    yield put({
      type: actionTypes.addCharityFailType,
      payload: error,
      prevData: charityData,
    });
  }
}

export function* fetchPendingGrant() {
  yield takeLatest(actionTypes.fetchPendGrantType, pendingGrantWorker);
}

export function* pendingGrantWorker(action) {
  try {
    const response = yield call(fetchAccountData, action.payload);
    yield put({
      type: actionTypes.fetchPendGrantSuccessType,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: actionTypes.fetchPendGrantFailType, error });
  }
}

export default function* grantsSagaWatcher() {
  yield all([fork(fetchGrantsDashboardDataWatcher)]);
  yield all([fork(fetchLazyDataWatcher)]);
  yield all([fork(putChartDataWatcher)]);
  yield all([
    fork(postSearchCharity),
    fork(postSearchCity),
    fork(postSearchCounty),
    fork(updateFrom),
    fork(fetchSearchGemini),
    fork(updateLoadMoreFrom),
    fork(fetchSelectedAccount),
    fork(removeCharityWatcher),
    fork(fetchSavedCharityWatcher),
    fork(submitSavedDataWatcher),
    fork(submitSavedGeminiDataWatcher),
    fork(addCharityWatcher),
    fork(fetchPendingGrant),
  ]);
}
